import { SaveButton } from "components/Buttons"
import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, Row } from "reactstrap"
import ReactDragListView from "react-drag-listview/lib/ReactDragListView"
import Table from "components/Table"
import { mapListItemsToApi, mapUpdatedListItemsToApi } from "../utils"
import ModalComponent from "components/Modals"
import ListMenuItem from "./listMenuItem"
import listOfListsColumns from "./listOfListsColumns"
import {
  addNewList,
  deleteListItem,
  getListOfLists,
  hideDeleteListModal,
  openDeleteListModal,
  resetListOfLists,
  updateList,
  updateListFeature,
  updateListOrder,
} from "store/actions"
import PropTypes from "prop-types"
import { LoadingIndicator } from "components/LoadingIndicator"

const ListOfLists = props => {
  const [renderListForm, setRenderListForm] = useState(false)
  const [editableItem, setEditableItem] = useState(null)
  const [notificationModalIsOpen, setNotificationModalIsOpen] = useState(false)
  const [publishProps, setPublishProps] = useState(null)
  const selectedEventRef = useRef(props.selectedEvent)
  const [notificationUpdateModalIsOpen, setNotificationUpdateModalIsOpen] =
    useState(false)
  const [updateProps, setUpdateProps] = useState(null)

  useEffect(() => {
    if (props.selectedEvent) {
      selectedEventRef.current = props.selectedEvent
    }
  }, [props.selectedEvent])

  useEffect(() => {
    props.getListOfLists({
      event_id: props?.selectedEvent?.id,
      menu_item_id: props.feature.id,
    })
    return () => {
      props?.resetListOfLists()
    }
  }, [])

  const handleAddListItem = data => {
    if (!editableItem) {
      const listItems = mapListItemsToApi(
        data.list_form.listItems,
        props.vendorId
      )
      const listFeature = {
        business_unit_id: props?.selectedEvent?.business_unit_id,
        event_id: props?.selectedEvent?.id,
        menu_feature: 0,
        menu_item_id: props.feature.id,
        name: data.list_form.name,
        order: props.listOfLists.length + 1,
        status: props.feature.status ? 1 : 0,
        user_id: props.userId,
        vendor_id: props.vendorId,
      }
      props.addNewList({ listItems: listItems, listFeature: listFeature })
      setRenderListForm(false)
    } else {
      const listItems = data.list_form.listItems.map((item, index) => ({
        ...item,
        order: index,
      }))
      const newListItems = mapListItemsToApi(
        listItems.filter(item => !item?.id),
        props.vendorId
      )
      const updatedListItems = mapUpdatedListItemsToApi(
        listItems.filter(item => item?.id),
        props.vendorId
      )
      const listFeature = { ...editableItem, name: data.list_form.name }
      const propsData = {
        newListItems: newListItems,
        updatedListItems: updatedListItems,
        listFeature: listFeature,
      }
      if (newListItems && newListItems?.length > 0 && editableItem?.status) {
        setUpdateProps(propsData)
        setNotificationUpdateModalIsOpen(true)
      } else {
        props.updateList(propsData)
      }
      setRenderListForm(false)
      setEditableItem(null)
    }
  }

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const sortedList = [...props.listOfLists].sort(
        (a, b) => a.order - b.order
      )
      const modifiedList = [...sortedList]

      const item = modifiedList.splice(fromIndex, 1)[0]
      modifiedList.splice(toIndex, 0, item)

      const modifiedItems = modifiedList.map((item, index) => {
        if (item.id !== sortedList[index].id) {
          return { ...item, order: index + 1 }
        } else {
          return null
        }
      })

      modifiedItems.forEach(item => {
        if (item) {
          props.updateListOrder({
            ...item,
            list_items: item.list_items.map(x => x.id),
            send_notification: false,
          })
        }
      })
    },
    nodeSelector: "tr",
    handleSelector: "tr",
    lineClassName: "dragDropLine",
  }

  const statusChangeHandler = (item, status) => {
    const selectedEvent = selectedEventRef?.current
    const data = {
      ...item,
      list_items: item.list_items.map(x => x.id),
      status: status,
    }
    if (status) {
      if (props.isEventFeature) {
        if (selectedEvent?.published) {
          setPublishProps(data)
          setNotificationModalIsOpen(true)
        } else {
          props.updateListFeature(data)
        }
      } else {
        setPublishProps(data)
        setNotificationModalIsOpen(true)
      }
    } else {
      props.updateListFeature(data)
    }
  }

  const editListActionHandler = item => {
    setEditableItem(item)
    setRenderListForm(true)
  }

  const [selectedListItem, setSelectedListItem] = useState()
  const deleteListActionHandler = item => {
    setSelectedListItem(item)
    props.openDeleteListModal()
  }

  const actions = [
    {
      name: "Edit",
      onClick: editListActionHandler,
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: deleteListActionHandler,
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  return (
    <>
      {renderListForm ? (
        <ListMenuItem
          feature={
            editableItem
              ? { entity_id: editableItem?.id, label: "" }
              : { ...props.feature, label: "" }
          }
          handleAddListItem={handleAddListItem}
          isListItem={true}
          backButtonHandler={() => {
            setRenderListForm(false)
            setEditableItem(null)
          }}
          design={props.design}
        />
      ) : props?.listLoading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row>
              <Col>
                <h3>{props.feature.label}</h3>
              </Col>
            </Row>
            <Row className="mt-2">
              <ReactDragListView {...dragProps}>
                <Table
                  data={props.listOfLists}
                  columns={listOfListsColumns(statusChangeHandler)}
                  classes={"table align-middle"}
                  actions={actions}
                />
              </ReactDragListView>
            </Row>
            <Row>
              <Col xl={3}>
                <SaveButton
                  fullWidth={true}
                  type="button"
                  content="Add New List"
                  onClick={() => setRenderListForm(true)}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
      <ModalComponent
        title={`Delete List - ${selectedListItem?.name}`}
        open={props.isDeleteListModalOpen}
        onClose={props.hideDeleteListModal}
      >
        <Row>
          <h5>Are you sure you want to delete this list?</h5>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={props.hideDeleteListModal}
            />
          </Col>
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              content="Delete"
              onClick={() =>
                props.deleteListItem({
                  listId: selectedListItem.id,
                  menu_item_id: selectedListItem.menu_item_id,
                })
              }
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        open={notificationModalIsOpen}
        onClose={() => setNotificationModalIsOpen(false)}
      >
        <Row>
          <h5>
            Would you like to send a notification to your users that this list
            has been created?
          </h5>
        </Row>
        <Row className="mt-3 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              content="No"
              onClick={() => {
                if (publishProps) {
                  props.updateListFeature(publishProps)
                }
                setNotificationModalIsOpen(false)
              }}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Yes"
              onClick={() => {
                if (publishProps) {
                  props.updateListFeature({
                    ...publishProps,
                    send_notification: 1,
                  })
                }
                setNotificationModalIsOpen(false)
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        open={notificationUpdateModalIsOpen}
        onClose={() => setNotificationUpdateModalIsOpen(false)}
      >
        <Row>
          <h5>
            Would you like to send a notification to your users that a new list
            item has been added to this list?
          </h5>
        </Row>
        <Row className="mt-3 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              content="No"
              onClick={() => {
                if (updateProps) {
                  props.updateList(updateProps)
                }
                setNotificationUpdateModalIsOpen(false)
              }}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Yes"
              onClick={() => {
                if (updateProps) {
                  props.updateList({
                    ...updateProps,
                    listFeature: {
                      ...updateProps?.listFeature,
                      send_list_item_notification: true,
                    },
                  })
                }
                setNotificationUpdateModalIsOpen(false)
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
    </>
  )
}

const mapStateToProps = state => ({
  listOfLists: state.List.listOfLists,
  selectedEvent: state.experiences.selectedEvent,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  isDeleteListModalOpen: state.List.isDeleteListModalOpen,
  listLoading: state.List.listLoading,
})

const mapDispatchToProps = dispatch => ({
  getListOfLists: values => dispatch(getListOfLists(values)),
  addNewList: values => dispatch(addNewList(values)),
  updateList: values => dispatch(updateList(values)),
  deleteListItem: values => dispatch(deleteListItem(values)),
  openDeleteListModal: () => dispatch(openDeleteListModal()),
  hideDeleteListModal: () => dispatch(hideDeleteListModal()),
  updateListFeature: values => dispatch(updateListFeature(values)),
  updateListOrder: values => dispatch(updateListOrder(values)),
  resetListOfLists: () => dispatch(resetListOfLists()),
})

ListOfLists.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(ListOfLists)
